module.exports = __webpack_public_path__ + "static/am-pm-infographic-e9e20bba19ce58cf91f6e4717798d741.png";